export default __webpack_public_path__ + "/assets/map-pin-blue-filled.2f36925fb8990454f6604efb33f902dc.png";